import React, { useState, useEffect, useRef } from "react";
import {
  Modal, Box, Typography, TextField, Select, MenuItem, Button,
  IconButton, Divider, InputLabel, FormControl, GlobalStyles
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Editor } from "@tinymce/tinymce-react";
import { developerTollApi } from "../../services/developerTollApi";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  maxHeight: "90dvh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
};

const AddProduct = ({ openEditor, handleClose, selectedProduct, allProducts, productEdit, fetchAllProducts }) => {
  const [productName, setProductName] = useState("");
  const [productSsoUrl, setProductSsoUrl] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productType, setProductType] = useState("");
  const [body, setBody] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (selectedProduct && openEditor) {
      setProductName(selectedProduct.product_name || "");
      setProductDescription(selectedProduct.description || "");
      if (typeof selectedProduct.is_public === "boolean") {
        console.log(selectedProduct.is_public)
        setProductType(selectedProduct.is_public ? "public" : "private");
      } else {
        console.log(selectedProduct.is_public)
        setProductType("");
      }
      setBody(selectedProduct.documentation || "");
      setProductSsoUrl(selectedProduct?.sso_path);
    }
    else{
      setProductName("");
      setProductDescription("");
      setProductType("");
      setBody("");
    }
  }, [selectedProduct, openEditor]);

  const handleSave = async () => {
    console.log({ productName, productDescription, productType, body });
    const payload={
      product_name: productName,
      description: productDescription,
      is_public: productType == 'public' ? true : false,
      documentation: body,
      sso_path: productSsoUrl,
    }

    if (productEdit && selectedProduct?.product_id) {
      payload.product_id = selectedProduct.product_id;
    }
    setLoader(true);
    try {
      let response;
      if (productEdit && selectedProduct?.product_id) {
        response = await developerTollApi.updateProduct(payload);
      } else {
        response = await developerTollApi.addProduct(payload);
      }
      console.log(response)
      if(response?.status)
      {
        handleClose();
        fetchAllProducts();
      }
    } catch (error) {
        console.error("Error fetching line chart data:", error);
    } finally {
        setLoader(false);
    }
  };

  return (
    <Modal open={openEditor} onClose={handleClose} disableEnforceFocus>
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="20px 30px">
          <Typography sx={{ fontSize: '18px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>Create Product</Typography>
          <Box>
            <IconButton onClick={handleClose}><CloseIcon /></IconButton>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ p: "20px 30px", overflow: "auto", maxHeight: "calc(100vh - 245px)" }}>
          <Box>
            <TextField
              variant="outlined"
              name="product_name"
              label="Product Name"
              type="text"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: productName ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: productName ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: productName ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>
          <Box mt={2}>
            <TextField
              variant="outlined"
              name="description"
              label="Description"
              type="text"
              value={productDescription}
              onChange={(e) => setProductDescription(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: productDescription ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: productDescription ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: productDescription ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>
          <Box mt={2}>
            <TextField
              variant="outlined"
              name="Product_Url"
              label="Product Url"
              type="text"
              value={productSsoUrl}
              onChange={(e) => setProductSsoUrl(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: productSsoUrl ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: productSsoUrl ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: productDescription ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>
          <FormControl fullWidth sx={{ mt: 2}}>
            <InputLabel sx={{ fontSize: "16px", color: "#6F6F6F", transform: productType ? "translate(14px, -9px) scale(0.9)" : "translate(14px, 10px) scale(1)", "&.Mui-focused": { color: "#1D1D1D",transform: "translate(14px, -9px) scale(0.9)" }, }}>Product Type</InputLabel>
            <Select
              value={productType}
              onChange={(e) => setProductType(e.target.value)}
              label="Product Type"
              required
              sx={{
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#DFDFDF",
                height: 45,
                  fontSize: "16px",
                  fontWeight: "500",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRadius: "10px",
                  borderColor: "#DFDFDF",
                  "& fieldset": {
                    borderColor: "#DFDFDF",
                    borderWidth: "1px",
                  },
                  "&:hover fieldset": {
                    borderColor: "#DFDFDF",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#DFDFDF",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
            >
                <MenuItem key="public" value="public">
                  Public
                </MenuItem>
                <MenuItem key="private" value="private">
                  Private
                </MenuItem>
            </Select>
          </FormControl>

          <Box mt={2}>
            <Typography mb={1}>Documentation</Typography>
            <GlobalStyles styles={{
                '.tox-promotion': { display: 'none !important' },
                '.tox-statusbar__branding': { display: 'none !important' },
                '.tox-tinymce': { border: '1px solid #DFDFDF !important' },
            }} />
            <Editor
              apiKey='ejfq37hgybsrwmucu0b2ec7eswr1e3r0t85x0tze0snanjkq'
              value={body || "Product Documentation"}
              onEditorChange={(newValue) => setBody(newValue)}
              init={{
                theme: "silver",
                branding: false,
                promotion: false, 
                plugins: [
                  'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link',
                  'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount', "code",
                ],
                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link table code | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                tinycomments_mode: 'embedded',
                tinycomments_author: 'Author name',
                valid_elements: '*[*]',
                valid_styles: {
                  '*': 'color,font-size,font-weight,font-style,text-decoration,float,' +
                      'margin,margin-top,margin-right,margin-bottom,margin-left,' +
                      'padding,padding-top,padding-right,padding-bottom,padding-left,' +
                      'background,background-color'
                },
                paste_data_images: true,
                paste_retain_style_properties: "all",
                fullpage_default_doctype: '<!DOCTYPE html>',
                fullpage: true,
                importcss_append: true,
                content_css: false,
                relative_urls: false,
                remove_script_host: false,
                convert_urls: false,
                extended_valid_elements: 'style[type|media]',
                valid_children: '+head[style],+body[style]',
                paste_webkit_styles: "all",
                paste_data_images: true,
                paste_preprocess: (plugin, args) => {
                  args.content = args.content.replace(/<style[^>]*>/g, '<style>').replace(/<\/style>/g, '</style>');
                },
              }}
            />

          </Box>
        </Box>

        <Divider mt="10px" />

        <Box display="flex" justifyContent="end" alignItems="center" p="20px 30px" gap="15px">
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={handleClose} >
                Cancel
            </Button>
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, "&:hover": {background: "#185CB7", color: "#ffffff", borderColor: "#185CB7"} }} onClick={handleSave} >
                Save
            </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddProduct;
